import React, { useContext, useEffect, useState } from 'react';
import { AgFinancingInput, Phase2Input } from '@indigo-ag/schema';
import { DialogContent, DialogProps, Body } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

import { EnhancedDialog, ModalActionButtons, Phase2Util } from 'shared';
import { Phase2Context } from '../Phase2';
import { UserContext } from 'core/components/GateWay/GateWay';

export interface IExternalPhases {
  flc: boolean;
  luchesi: boolean;
  terramagna: boolean;
}

interface StartAnalysisModalProps extends DialogProps {
  closeModal: () => void;
  startExternalProcess: IExternalPhases;
}

export const StartAnalysisModal: React.FunctionComponent<StartAnalysisModalProps> = ({
  closeModal,
  startExternalProcess,
  open
}) => {
  /**
   * State
   */
  const [disclaimerMsg, setDisclaimerMsg] = useState(i18next.t('analysisCollateralAndCreditDisclaimer'));

  /**
   * Phase 2 Context
   */
  const { updatePhase } = useContext(Phase2Context);
  const { fullName } = useContext(UserContext);

  useEffect(() => {
    if (startExternalProcess.flc) {
      setDisclaimerMsg(i18next.t('analysisCreditDisclaimer'));
    } else if (startExternalProcess.luchesi) {
      setDisclaimerMsg(i18next.t('analysisCollateralDisclaimer'));
    } else if (startExternalProcess.terramagna) {
      setDisclaimerMsg(i18next.t('analysisFieldMonitoringDisclaimer'));
    }
  }, [startExternalProcess]);

  const handleSave = () => {
    const updatedPhaseInfo: Partial<AgFinancingInput> = Phase2Util.autoStartPhase2(
      {},
      startExternalProcess.flc,
      startExternalProcess.luchesi,
      startExternalProcess.terramagna,
      fullName
    );
    return updatePhase(updatedPhaseInfo.phase2 as Phase2Input);
  };

  return (
    <EnhancedDialog
      open={open}
      onClose={closeModal}
      title={i18next.t('alert')}
      dialogMaxWidth="480px"
      dialogMinHeight="200px"
    >
      <DialogContent>
        <Body>{disclaimerMsg}</Body>
      </DialogContent>
      <ModalActionButtons
        closeModal={closeModal}
        disabled={false}
        save={handleSave}
        changeButtonName={i18next.t('start')}
      />
    </EnhancedDialog>
  );
};
